// TR
export const locale = {
    common: {
        detail: "Detay",
        edit: "Düzenle",
        delete: "Sil",
        yes: "Evet",
        no: "Hayır",
        new: "Yeni",
        back: "Geri",
        language: "Dil",
        currency: "Para Birimi",
        cancel: "Vazgeç",
        send: "Gönder",
        confirm: "Devam Et",
        date: "Tarih",
        save: "Kaydet",
        report: "Bildir",
        active: "Aktif",
        passive: "Pasif",
        remove: "Sil",
        action: "İşlem",
        search: "Ara",
        ok: "Tamam",
        close: "Kapat",
        preview: "Önizleme",
        today: "Bugün",
        daily: "Günlük",
        weekly: "Haftalık",
        monthly: "Aylık",
        yearly: "Yıllık",
        month: "Ay",
        day: "Gün",
        year: "Yıl",
        week: "Hafta",
        viewAll: "Tümü",
        notification: "Bildirim",
        download: "İndir",
        optional: "Opsiyonel",
        permission: "Yetki",
        manager: "Yönetici",
        default: "Varsayılan",
        status: "Durum",
        sort: "Sıra",
        createdAt: "Oluşturulma Tarihi",
        createdAtShort: "Oluşturulma",
        chooseSelect: "Seçim yapın.",
        chooseSelectShort: "Seçiniz",
        chooseOption: "Özellik seçimi yapın",
        canChooseOption: "Özellik seçimi yapabilirsiniz",
        chooseDate: "Tarih seçimi yapın.",
        chooseTime: "Saat seçimi yapın.",
        chooseDateAndTime: "Tarih ve saat seçimi yapın.",
        individual: "Bireysel",
        corporate: "Kurumsal",
        cash: "Peşin",
        system: "Sistem",
        export: "Dışa Aktar",
        overview: "Genel Bakış",
        settings: "Ayarlar",
        credentials: "Kimlik Bilgileri",
        homePage: "Anasayfa",
        id: "ID",
        true: "Doğru",
        false: "Yanlış",
        hour: "Saat",
        minute: "Dakika",
        second: "Saniye",
        empty: "Boş",
        indefinite: "Süresiz",
        ipAddress: "İp Adresi",
        userAgent: "User Agent",
        immediately: "Hemen",
        exportTooltip: "Filtreleme yapılmadığında liste maksimum 1.000 kayıt olarak sınırlandırılacaktır.",
        translation: "Çeviri",
        notificationCount: "Bildirim Sayısı",
        weather_word: "Hava",
        condition_word: "Durumu",
        storage: {
            quotaNotFound: 'Bir depolama planına sahip değilsiniz. Lütfen bir depolama planı satın alınız.',
            quotaExceeded: 'Depolama alanınız doldu. Lütfen depolama planınızı yükseltin veya yer açın.',
        },
        panelSettings: {
            alwaysOnTop: 'Her zaman üstte',
            openOnLoad: 'Pencere açık gelsin',
            resetWindowSize: 'Pencere Boyutunu Sıfırla',
            resetInnerLayout: 'İç Düzeni Sıfırla',
            transparent: 'Arkaplanı saydamlaştır',
        },
        dock: {
            minimize: 'Küçült',
            autoHide: "Dock'u otomatik gizle",
            customize: "Dock'u Özelleştir...",
            removeFromDock: "Dock'tan Kaldır",
            close: 'Kapat',
            pages: 'Sayfalar',
            panels: 'Paneller',
            settings: 'Ayarlar',
            magnification: 'Büyütme efekti',
            magnificationScale: 'Büyütme',
            clickAnimation: 'Tıklama efekti',
            bounceAnimation: 'Zıplama efekti',
            bounceOnOpen: 'Uygulama açılışında zıplat',
            positionBottom: 'Aşağı',
            positionRight: 'Sağ',
            position: 'Konum',
            resetOrder: 'Öğe Sırasını Sıfırla',
            resetCustomizations: 'Boyutu ve Ayarları Sıfırla',
            weatherAnimation: 'Animasyon',
            musicAnimation: 'Animasyon',
            musicStop: 'Müziği Durdur ve Kapat',
        },
        spotlight: {
            title: 'Spotlight',
            placeholder: 'Müşteri, araç, ürün, not ara...',
            noResults: 'Sonuç bulunamadı',
            emptyState: 'Sonuçları görmek için arayın..',
            keepTyping: 'Aramak için yazmaya devam edin...',
            copied: 'Kopyalandı',
            currencyError: 'Kur bilgisi alınamadı',
            stockQty: 'Stok: {count}',
            noPaymentInfo: 'Ödeme bilgisi yok',
            fileOrphan: 'Bağımsız dosya',
            fileMultipleRelations: 'Bu dosya birden fazla yerde kullanılıyor. Hangisini açmak istersiniz?',
            subfolder: 'Alt klasör',
            remaining: 'kalan',
            quickActions: {
                prefix: 'yeni',
                title: 'Hızlı İşlemler',
                newNote: 'Yeni Not Oluştur',
                newEvent: 'Yeni Etkinlik Oluştur',
                newVWO: 'Yeni Araç İş Emri',
                newSWO: 'Yeni Servis İş Emri',
                newCustomer: 'Yeni Müşteri',
                newOfficer: 'Yeni Çalışan',
                hintNote: 'Not panelini aç',
                hintAgenda: 'Ajanda panelini aç',
                hintVWO: 'Araç iş emri oluştur',
                hintSWO: 'Servis iş emri oluştur',
                hintCustomer: 'Müşteri kaydı oluştur',
                hintOfficer: 'Çalışan kaydı oluştur',
                keywordsNote: 'not,note',
                keywordsAgenda: 'ajanda,etkinlik,takvim,randevu',
                keywordsVWO: 'iş emri,is emri,servis,araç iş,araç servis',
                keywordsSWO: 'iş emri,is emri,servis',
                keywordsCustomer: 'müşteri,musteri,customer',
                keywordsOfficer: 'çalışan,calisan,personel,yetkili',
            },
            groups: {
                CUSTOMERS: 'Müşteriler',
                VEHICLES: 'Araçlar',
                OFFICERS: 'Yetkililer',
                STOCKS: 'Ürünler',
                USERS: 'Kullanıcılar',
                COMPANIES: 'Şirketler',
                MODULE_VEHICLE_WORK_ORDER: 'İş Emirleri',
                MODULE_NOTE: 'Notlar',
                MODULE_AGENDA: 'Ajanda',
                MODULE_WEATHER: 'Hava Durumu',
                FILES: 'Dosyalar',
                FILE_FOLDERS: 'Dosya Klasörleri',
                MODULE_MUSIC_TRACKS: 'Parçalar',
                MODULE_MUSIC_PLAYLISTS: 'Çalma Listeleri',
            },
            weather: {
                pending: 'Hava durumu yükleniyor...',
                feelsLike: 'Hissedilen',
                tomorrow: 'Yarın'
            },
            guide: {
                title: 'Spotlight Kullanım Kılavuzu',
                searchTitle: 'Genel Arama',
                searchDesc: 'Müşteri, araç, ürün, not, ajanda ve iş emri gibi tüm kayıtlarda arama yapın. En az 2 karakter yazmanız yeterli.',
                prefixTitle: 'Özel Arama (Prefix)',
                prefixDesc: 'Sadece belirli bir kategoride arama yapmak için başına kısa kod ekleyin.',
                prefixCustomer: 'Müşteri',
                prefixVehicle: 'Araç',
                prefixStock: 'Ürün',
                prefixWorkOrder: 'İş Emri',
                prefixNote: 'Not',
                prefixAgenda: 'Ajanda',
                prefixDemoTerm: 'Berkay',
                prefixDemoDesc: 'Müşterilerde "Berkay" aranır',
                exampleCustomer: 'Berkay Aksoy',
                exampleVehicle: '34 ABC 123',
                exampleStock: 'Şarj Aleti',
                mathTitle: 'Matematik Hesaplama',
                mathDesc: 'Doğrudan matematik işlemi yazarak anında sonuç alın. Sonuca tıklayarak kopyalayabilirsiniz.',
                currencyTitle: 'Döviz Çevirme',
                currencyDesc: 'Tutarın yanına para birimi sembolü veya kodu yazarak anlık kur çevirimi yapın.',
                unitTitle: 'Birim Çevirme',
                unitDesc: 'Uzunluk, ağırlık, hacim, sıcaklık, veri ve zaman birimlerini anında çevirin.',
                unitEx1Input: '1kg kaç gram',
                unitEx1Result: '1.000 g',
                unitEx2Input: '5 mil kaç km',
                unitEx2Result: '8,05 km',
                unitEx3Input: '100 fahrenheit -> celsius',
                unitEx3Result: '37,78 °C',
                unitEx4Input: '3600 sn kaç dk',
                unitEx4Result: '60 dk',
                prefixWeather: 'Hava Durumu',
                weatherTitle: 'Hava Durumu',
                weatherDesc: 'Şehir adı yazarak anlık hava durumu bilgisini görüntüleyin. Prefix veya doğal dil ile arama yapabilirsiniz.',
                weatherEx1Input: 'hava:bolu',
                weatherEx1Result: 'Bolu hava durumu',
                weatherEx2Input: 'istanbul hava',
                weatherEx2Result: 'İstanbul hava durumu',
                weatherEx3Input: 'ankara kaç derece',
                weatherEx3Result: 'Ankara sıcaklık',
                weatherPrefixLabel: 'Hava durumu',
                weatherPrefixShort: 'Kısa prefix',
                shortcutsTitle: 'Klavye Kısayolları',
                shortcutToggle: 'Spotlight aç/kapat',
                shortcutNavigate: 'Sonuçlar arası gezin',
                shortcutSelect: 'Seçili sonucu aç',
                shortcutEsc: 'Aramayı temizle / kapat',
            },
        },
        weather: {
            title: 'Hava Durumu',
            sidebar: 'Kenar Çubuğu',
            search: 'Şehir ara...',
            addLocation: 'Konum Ekle',
            detectLocation: 'Konumumu Bul',
            myLocation: 'Konumum',
            setDefault: 'Varsayılan Yap',
            removeLocation: 'Kaldır',
            noLocations: 'Henüz konum eklenmedi',
            maxLocations: 'Konum ekleme sınırına ulaşıldı',
            removeConfirm: 'konumu kaldırılsın mı?',
            noResults: 'Sonuç bulunamadı',
            hourly: 'Saatlik Tahmin',
            daily: '7 Günlük Tahmin',
            details: 'Detaylar',
            now: 'Şu An',
            humidity: 'Nem',
            wind: 'Rüzgar',
            uvIndex: 'UV İndeksi',
            pressure: 'Basınç',
            visibility: 'Görüş Mesafesi',
            sunrise: 'Gün Doğumu',
            sunset: 'Gün Batımı',
            feelsLike: 'Hissedilen',
            high: 'Y',
            low: 'D',
            refresh: 'Yenile',
            today: 'Bugün',
            loading: 'Yükleniyor...',
            locationError: 'Konum alınamadı',
            changeCity: 'Şehir Değiştir',
            precipChance: 'Yağış',
            sunriseShort: 'G.Doğumu',
            sunsetShort: 'G.Batımı',
            days: {
                mon: 'Pzt',
                tue: 'Sal',
                wed: 'Çar',
                thu: 'Per',
                fri: 'Cum',
                sat: 'Cmt',
                sun: 'Paz',
            },
            animations: 'Animasyonlar',
            accumulation: 'Birikme Efekti',
        },
        music: {
            title: 'Müzik',
            sidebar: 'Kenar Çubuğu',
            radio: 'Radyo',
            library: 'Kütüphane',
            myMusic: 'Müziğim',
            favorites: 'Favoriler',
            popular: 'Popüler',
            genres: 'Türler',
            recentlyPlayed: 'Son Çalınanlar',
            search: 'Radyo ara...',
            searchShort: 'Ara',
            nowPlaying: 'Şu An Çalınıyor',
            notPlaying: 'Henüz bir istasyon seçilmedi',
            addFavorite: 'Favorilere Ekle',
            removeFavorite: 'Favorilerden Çıkar',
            noFavorites: 'Henüz favori istasyon yok',
            noFavoritesHint: 'Beğendiğiniz istasyonları favorilere ekleyin',
            noResults: 'Sonuç bulunamadı',
            noResultsHint: 'Farklı bir arama terimi deneyin',
            animations: 'Animasyonlar',
            buffering: 'Bağlanılıyor...',
            streamError: 'Yayın bağlantısı kurulamadı',
            stop: 'Durdur',
            genrePop: 'Pop',
            genreRock: 'Rock',
            genreTurkish: 'Türkçe',
            genreJazz: 'Caz',
            genreClassical: 'Klasik',
            genreFolk: 'Halk Müziği',
            genreArabesk: 'Arabesk',
            genreNews: 'Haber',
            playlists: 'Çalma Listeleri',
            tracks: 'Şarkı',
            kbps: 'kbps',
            libraryComingSoon: 'Kütüphane yakında aktif olacak',
            noTracks: 'Henüz ses dosyası yok',
            noTracksHint: 'Yükle butonuyla ses dosyası ekleyebilirsiniz',
            loadMore: 'Daha Fazla',
            renamePlaylist: 'Yeniden Adlandır',
            deletePlaylist: 'Sil',
            deletePlaylistConfirm: '{name} listesini silmek istediğinize emin misiniz? Şarkılar kütüphanede kalır.',
            playlistName: 'Liste adı',
            searchTracks: 'Şarkı ara...',
            newPlaylist: 'Yeni Çalma Listesi',
            addToPlaylist: 'Çalma Listesine Ekle',
            removeFromPlaylist: 'Listeden Çıkar',
            addedToPlaylist: 'Listeye eklendi',
            upload: 'Yükle',
            refresh: 'Yenile',
            collapse: 'Küçült',
            shuffle: 'Karıştır',
            repeat: 'Yinele',
            repeatAll: 'Tümünü Yinele',
            repeatOne: 'Bir Şarkıyı Yinele',
            favorite: 'Favori',
            selectMode: 'Seç',
            selected: 'seçili',
            deleteTrack: 'Sil',
            selectAll: 'Tümünü Seç',
            trackUnit: 'şarkı',
            detail_artist: 'Sanatçı',
            detail_album: 'Albüm',
            detail_genre: 'Tür',
            detail_year: 'Yıl',
            detail_format: 'Format',
            detail_size: 'Boyut',
            noPlaylists: 'Henüz çalma listesi yok',
        },
        billing: {
            title: 'Abonelik',
            sidebar: 'Kenar Çubuğu',
            active: 'Aktif',
            renews: 'yenilenir',
            general: 'GENEL',
            myAccount: 'HESABIM',
            packages: 'Paketler',
            modules: 'Modüller',
            orders: 'Siparişler',
            wallet: 'Cüzdan',
            cards: 'Kartlarım',
            monthly: 'Aylık',
            yearly: 'Yıllık',
            save: 'tasarruf',
            month: 'ay',
            yearlyTotal: 'Yıllık toplam',
            currentPlan: 'Mevcut Plan',
            upgrade: 'Yükselt',
            switchPlan: 'Geçiş Yap',
            popular: 'Popüler',
            modulesTitle: 'Modül Mağazası',
            filterAll: 'Tümü',
            filterOwned: 'Sahip Olunan',
            filterAvailable: 'Satın Alınabilir',
            owned: 'Sahip',
            free: 'Ücretsiz',
            module: 'Modülü',
            buyNow: 'Satın Al',
            orderHistory: 'Sipariş Geçmişi',
            orderPrefix: 'Sipariş',
            backToOrders: 'Geri',
            transactions: 'İşlemler',
            error: 'Hata',
            cancelOrder: 'İptal Et',
            retry: 'Tekrar Dene',
            noTransactions: 'İşlem bulunamadı',
            status_completed: 'Tamamlandı',
            status_failed: 'Başarısız',
            status_cancelled: 'İptal Edildi',
            walletBalance: 'Cüzdan Bakiyeniz',
            topUp: 'Bakiye Yükle',
            topUpAmount: 'Bakiye Yükleme',
            customAmount: 'Özel tutar',
            loadBalance: 'Yükle',
            walletHistory: 'Cüzdan Geçmişi',
            savedCards: 'Kayıtlı Kartlar',
            addCard: 'Yeni Kart',
            addNewCard: 'Yeni Kart Ekle',
            cardNumber: 'Kart Numarası',
            cardExpiry: 'Son Kullanma',
            cardHolder: 'Kart Sahibi',
            cardHolderPlaceholder: 'Ad Soyad',
            saveCard: 'Kaydet',
            default: 'Varsayılan',
            setDefault: 'Varsayılan Yap',
            cancelAction: 'Vazgeç',
            stepAddress: 'Adres',
            stepPayment: 'Ödeme',
            stepConfirm: 'Onay',
            billingAddress: 'FATURA ADRESİ',
            paymentMethod: 'ÖDEME YÖNTEMİ',
            creditCard: 'Kredi Kartı',
            walletPay: 'Cüzdan',
            bankTransfer: 'Havale',
            discountCode: 'İNDİRİM KODU',
            enterCode: 'Kod girin',
            apply: 'Uygula',
            discountApplied: 'indirim uygulandı',
            orderSummary: 'SİPARİŞ ÖZETİ',
            product: 'Ürün',
            discount: 'İndirim',
            total: 'Toplam',
            paymentLabel: 'Ödeme',
            addressLabel: 'Adres',
            agreeTerms: 'Satış şartlarını kabul ediyorum',
            back: 'Geri',
            continue: 'Devam Et',
            confirmOrder: 'Siparişi Onayla',
            addAddress: 'Yeni Adres Ekle',
            addNewAddress: 'Yeni Adres Ekle',
            addressTitle: 'Adres Başlığı',
            addressTitlePlaceholder: 'Ev Adresi',
            addressLine: 'Adres',
            addressLinePlaceholder: 'Mahalle, cadde, sokak, no',
            district: 'İlçe',
            city: 'İl',
            saveAddress: 'Kaydet',
            invalidCode: 'Geçersiz indirim kodu',
            payWithNewCard: 'Yeni kart ile öde',
            savings: 'tasarruf',
            discountWord: 'indirim',
            remove: 'Kaldır',
            processing: 'İşleniyor...',
            processingDesc: 'Ödemeniz işleniyor, lütfen bekleyin',
            paymentSuccess: 'Ödemeniz Alındı!',
            paymentFailed: 'Ödeme Başarısız',
            goToOrders: 'Siparişlere Git',
            close: 'Kapat',
            externalPaymentSuccess: 'Ödemeniz Başarıyla Alındı',
            externalPaymentFailed: 'Ödeme İşlemi Başarısız',
            openBillingPanel: 'Abonelik Panelini Aç',
        },
        dataTable: {
            title: 'Veri Tablosu',
            noData: 'Gösterilecek veri yok',
            noResults: 'Sonuç bulunamadı',
            loadMore: 'Daha Fazla Yükle',
            loading: 'Yükleniyor...',
            selectedCount: '{count} öğe seçili',
            totalCount: 'kayıt',
            export: 'Dışa Aktar',
            clearFilters: 'Temizle',
            selectAll: 'Tümünü Seç',
            editCell: 'Düzenle',
            expandRow: 'Genişlet',
            columns: 'Kolonlar',
            search: 'Ara...',
            filters: 'Sonuçları Filtrele',
            actions: 'İşlemler',
            sortAsc: 'Artan',
            sortDesc: 'Azalan',
            dateFrom: 'Başlangıç',
            dateTo: 'Bitiş',
        },
        fileManager: {
            title: 'Dosya Yöneticisi',
            titlePicker: 'Dosya Yönetimi',
            selectFile: 'Dosya Seç',
            refresh: 'Yenile',
            sidebar: 'Kenar Çubuğu',
            categories: 'Kategoriler',
            allFiles: 'Tüm Dosyalar',
            noteAttachments: 'Not Ekleri',
            workOrderAttachments: 'İş Emri Ekleri',
            musicFiles: 'Müzik Dosyaları',
            playlistFiles: 'Çalma Listeleri',
            independentFiles: 'Bağımsız Dosyalar',
            trash: 'Çöp Kutusu',
            folders: 'Klasörler',
            expandAll: 'Tümünü Aç',
            collapseAll: 'Tümünü Kapat',
            newFolder: 'Yeni Klasör',
            newSubFolder: 'Yeni Alt Klasör',
            folderName: 'Klasör adı',
            noFolders: 'Henüz klasör yok',
            noResults: 'Sonuç bulunamadı',
            trashEmpty: 'Çöp kutusu boş',
            folderEmpty: 'Bu klasör boş',
            moduleEmpty: 'Henüz içerik yok',
            trashHint: 'Silinen dosyalar burada görüntülenir',
            uploadHint: 'Dosya sürükleyin veya yükle butonunu kullanın',
            name: 'Ad',
            size: 'Boyut',
            type: 'Tür',
            date: 'Tarih',
            folder: 'Klasör',
            preview: 'Dosya Bilgisi',
            autoPreview: 'Önizleme',
            download: 'İndir',
            open: 'Aç',
            navigateToContent: 'İçeriğe Git',
            restore: 'Geri Yükle',
            permanentDelete: 'Kalıcı Sil',
            rename: 'Yeniden Adlandır',
            changeColor: 'Renk Değiştir',
            move: 'Taşı',
            uploadFile: 'Dosya Yükle',
            selectAll: 'Tümünü Seç',
            rootDirectory: 'Kök Dizin',
            deleteConfirmTitle: 'Silme Onayı',
            deleteConfirmSingle: 'Bu öğeyi silmek istediğinizden emin misiniz?',
            deleteConfirmMultiple: '{count} öğeyi silmek istediğinizden emin misiniz?',
            emptyTrash: 'Çöp Kutusunu Boşalt',
            emptyTrashConfirm: 'Çöp kutusundaki tüm öğeler kalıcı olarak silinecek. Bu işlem geri alınamaz.',
            continue: 'Devam Et',
            restoreAll: 'Tümünü Geri Yükle',
            restoreAllConfirm: 'Çöp kutusundaki tüm öğeler geri yüklenecek.',
            permanentDeleteTitle: 'Kalıcı Silme',
            permanentDeleteSingle: 'Bu öğe kalıcı olarak silinecek. Bu işlem geri alınamaz.',
            permanentDeleteMultiple: '{count} öğe kalıcı olarak silinecek. Bu işlem geri alınamaz.',
            depthLimitTitle: 'Klasör Sınırı',
            depthLimitMessage: 'Maksimum klasör derinliğine ulaşıldı.',
            depthLimitParent: 'Maksimum klasör derinliğine ulaşıldı. Bir üst klasöre eklemek ister misiniz?',
            depthLimitMove: 'Maksimum klasör derinliği aşıldığı için bu işlem tamamlanamıyor.',
            addToParent: 'Ekle',
            whichWorkOrder: 'Hangi İş Emri kaydına yüklenecek?',
            workOrderPrefix: 'İş Emri #',
            items: 'öğe',
            filesSelected: '{count} dosya seçildi',
            itemsSelected: 'öğe seçildi',
            select: 'Seç',
            statsFiles: '{count} dosya',
            statsFolders: '{count} klasör',
            statsFilesAndFolders: '{files} dosya, {folders} klasör',
            statsTemplate: '{files} dosya, {folders} klasör',
            pdfFile: 'PDF dosyası',
            pdfPreview: 'PDF Önizle',
            videoFile: 'Video dosyası',
            audioFile: 'Ses dosyası',
            goToContent: 'İçeriğe Git',
            metaSize: 'Boyut',
            metaType: 'Tür',
            fileType_image: 'Resim',
            fileType_pdf: 'PDF Belgesi',
            fileType_document: 'Belge',
            fileType_spreadsheet: 'Hesap Tablosu',
            fileType_archive: 'Arşiv',
            fileType_video: 'Video',
            fileType_audio: 'Ses',
            fileType_generic: 'Dosya',
            metaCreated: 'Oluşturulma',
            metaModified: 'Değiştirilme',
            metaModule: 'Modül',
            metaResolution: 'Çözünürlük',
            metaDuration: 'Süre',
            metaCamera: 'Kamera',
            metaExposure: 'Pozlama',
            metaTakenAt: 'Çekim Tarihi',
            metaGps: 'Konum',
            metaCodec: 'Ses Codec',
            metaPages: 'Sayfa',
            metaArtist: 'Sanatçı',
            metaAlbum: 'Albüm',
            metaGenre: 'Tür',
            viewMode: 'Görünüm',
            gridView: 'Izgara Görünümü',
            listView: 'Liste Görünümü',
            goBack: 'Geri',
            goForward: 'İleri',
            sort: 'Sırala',
            noteLabel: 'Not',
            workOrderLabel: 'İş Emri',
            musicLabel: 'Müzik',
            playlistLabel: 'Çalma Listesi',
            delete: 'Sil',
            files: 'Dosyalar',
            cancel: 'İptal',
            upload: 'Yükle',
            errorTitle: 'Hata',
            errorUpload: 'Dosya yüklenirken bir hata oluştu.',
            errorFolderCreate: 'Klasör oluşturulurken bir hata oluştu.',
            errorDelete: 'Silme işlemi sırasında bir hata oluştu.',
            errorRename: 'Yeniden adlandırma sırasında bir hata oluştu.',
            errorMove: 'Taşıma işlemi sırasında bir hata oluştu.',
            errorRestore: 'Geri yükleme sırasında bir hata oluştu.',
            errorPermanentDelete: 'Kalıcı silme sırasında bir hata oluştu.',
            detach: 'İlişkiyi Kaldır',
            detachConfirmTitle: 'İlişki Kaldırma',
            detachConfirmSingle: 'Bu dosyanın ilişkisi kaldırılacak. Dosya silinmeyecek.',
            detachConfirmMultiple: '{count} dosyanın ilişkisi kaldırılacak. Dosyalar silinmeyecek.',
            errorDetach: 'İlişki kaldırma sırasında bir hata oluştu.',
            uploadClose: 'Kapat',
            uploadCancel: 'Yüklemeyi İptal Et',
            uploadDrop: 'Bırakın',
            uploadDragFiles: 'Dosyaları sürükleyin',
            uploadOrClick: 'veya tıklayarak seçin',
            uploadDone: '{count} dosya yüklendi',
            uploadProgress: '{done}/{total} dosya yükleniyor',
            uploadFileCount: '{count} dosya',
            etaSeconds: '{n} sn kaldı',
            etaMinutes: '{n} dk kaldı',
            etaHours: '{n} sa kaldı',
            fileSelected: '1 dosya seçildi',
            selectAFile: 'Bir dosya seçin',
            manageFiles: 'Dosyaları yönetin',
            deselect: 'Seçimi Kaldır',
        },
        dashboard: {
            customize: "Özelleştir",
            customizeTooltip: "Widget Özelleştir",
            customizeTitle: "Widget Özelleştirme",
            customizeMenu: "Widget'ları Özelleştir",
            close: "Kapat",
            appearance: "Görünüm",
            glassMode: "Cam Efekti",
            glassModeDesc: "Şeffaf, bulanık arka plan",
            widgets: "Widget'lar",
            activeWidgets: "Aktif Widget'lar",
            addWidget: "Yeni Widget Ekle",
            showAll: "Hepsini Göster",
            hideAll: "Hepsini Gizle",
            reset: "Varsayılana Dön",
            resetConfirmTitle: "Varsayılana Dön",
            resetConfirmMessage: "Tüm widget sıralaması, boyutları ve görünürlük tercihleriniz sıfırlanacak. Devam edilsin mi?",
            resetConfirmAction: "Sıfırla",
            widgetTitles: {
                revenue: "Gelir",
                expenses: "Gider",
                outstanding: "Alacaklar",
                payables: "Borçlar",
                payment_methods: "Ödeme Yöntemleri",
                weather: "Hava Durumu",
                cash_register: "Kasa",
                low_stock: "Düşük Stok Uyarıları",
                stock: "Stok",
                storage_simple: "Depolama Özeti",
                subscriptions: "Abonelikler",
                subscription_summary: "Abonelik Özeti",
                sms_credit: "SMS Kredi",
                storage: "Depolama Kullanımı",
                agenda_upcoming: "Ajanda - Yaklaşanlar",
                work_order_recent: "İş Emri - Son Kayıtlar",
                work_order_status: "İş Emri Durumları",
                sms_credit_simple: "SMS Bakiye",
                sms_titles: "SMS Başlıkları",
                agenda_stats: "Ajanda İstatistik",
            },
            widgetEmpty: {
                subscriptionsTitle: "Aboneliğiniz bulunmuyor",
                subscriptionsSub: "Aktif veya geçmiş abonelik kaydınız yok",
                subscriptionSummaryTitle: "Takip edilecek abonelik yok",
                subscriptionSummarySub: "Aktif veya yaklaşan bir abonelik bulunmuyor",
                smsTitlesTitle: "Tanımlı SMS başlığı yok",
                smsTitlesSub: "{provider} sağlayıcısında onaylı bir başlığınız bulunmuyor",
                agendaUpcomingTitle: "Yaklaşan randevu yok",
                agendaUpcomingSub: "Bugün veya sonrası için planlanmış bir randevunuz bulunmuyor",
                lowStock: "Düşük stok yok",
                workOrderRecentTitle: "İş emri kaydı yok",
                workOrderRecentSub: "Seçili filtreye uygun bir iş emri bulunmuyor",
                workOrderStatusTitle: "İş emri kaydı yok",
                workOrderStatusSub: "Henüz oluşturulmuş bir iş emri bulunmuyor",
            },
            widgetLabels: {
                smsTitlesCount: "{count} başlık",
                lowStockProduct: "Ürün",
                lowStockStock: "Stok",
                lowStockStatus: "Durum",
                lowStockCritical: "Kritik",
                lowStockLow: "Düşük",
                ringOutstanding: "Tahsil",
                ringPayables: "Ödenen",
                ringStorage: "Kullanım",
                invoiceCount: "Fatura Adedi",
                totalAmount: "Toplam Tutar",
                remaining: "Kalan",
                total: "Toplam",
                used: "Kullanılan",
                subsUnlimited: "Süresiz",
                subsRemainingDays: "{days} gün kaldı",
                subsRemainingDaysShort: "{days} gün",
                subsStatus: "Durum",
                subsExpiry: "Bitiş",
                workOrderDistribution: "Dağılım",
                agendaNextLabel: "Sıradaki Randevu",
                agendaCountdownSuffix: "kaldı",
                agendaCountdownNow: "şimdi",
                woRecentStatusPlaceholder: "Durum",
                periodToday: "Bugün",
                periodWeek: "Hafta",
                periodMonth: "Ay",
                periodTotal: "Toplam",
                storageTypeWorkOrder: "Araç İş Emri",
                storageTypeNote: "Not",
                storageTypeMusic: "Müzik",
                storageTypeMusicPlaylist: "Müzik Listeleri",
                storageTypeFileManager: "Dosya Yöneticisi",
                storageTypeUnattached: "Bağımsız",
            },
            widgetFields: {
                provider: "Sağlayıcı",
                cashRegister: "Kasa",
                location: "Konum",
                woStatus: "Durum",
                woLimit: "Adet",
            },
            widgetOptions: {
                woStatusAll: "Tümü",
                woStatusOpen: "Açık",
                woStatusInProgress: "İşlemde",
                woStatusDone: "Tamamlandı",
                woStatusSupply: "Tedarik Bekleniyor",
                woStatusCanceled: "İptal Edildi",
                woStatusReturned: "İade Edildi",
            },
        },
        transaction: {
            title: "Tahsilat",
            titlePlural: "Tahsilatlar",
            direction: {
                1: "Tahsilat",
                2: "Ödeme",
            },
            status: {
                0: "Bekliyor",
                1: "Kısmi Ödendi",
                2: "Tamamen Ödendi",
                3: "İade Edildi",
                4: "İptal Edildi",
            },
            summary: {
                total: "Toplam Tutar",
                paid: "Ödenen",
                remaining: "Kalan",
                overPaid: "Fazla Ödeme",
            },
            source: {
                label: "Kaynak",
                goTo: "Kayda Git",
                manual: "Manuel Tahsilat",
            },
            sourceModules: {
                MODULE_VEHICLE_WORK_ORDER: "Araç İş Emri",
                COMPANY_CUSTOMER: "Müşteri",
            },
            payment: {
                title: "Ödemeler",
                count: "{count} ödeme kaydı",
                empty: "Henüz ödeme kaydı yok.",
                emptyHint: "İlk tahsilatı eklemek için sağdaki butonu kullan.",
                add: "Yeni Tahsilat",
                addTitle: "Yeni Tahsilat Ekle",
                edit: "Düzenle",
                editTitle: "Tahsilatı Düzenle",
                delete: "Sil",
                markPaid: "Tahsil Et",
                markPaidTitle: "Tahsil Et",
                method: "Ödeme Yöntemi",
                methodPlaceholder: "Yöntem seçin",
                cashRegister: "Kasa",
                cashRegisterPlaceholder: "Kasa seçin",
                cashRegisterDefault: "(Varsayılan)",
                amount: "Tutar",
                amountPlaceholder: "0,00",
                amountMaxHint: "Eklenebilir maks tutar: {amount}",
                amountExceedsHint: "Bu tutar, eklenebilir miktarı aşıyor. Yer açmak için bekleyen bir ödemeyi sil veya düzenle.",
                allocationFull: "Tüm tutar planlandı (bekleyen taksitler dahil). Yer açmak için bekleyen bir ödemeyi sil veya düzenle.",
                paidAt: "Tahsil Tarihi",
                paidAtNow: "Şimdi tahsil et",
                timing: "Tahsilat Zamanı",
                timingNow: "Şimdi Tahsil Et",
                timingDeferred: "Vadeli Kayıt",
                timingNowHint: "Tutar şimdi tahsil edilecek, seçilen kasaya gelir olarak işlenir.",
                timingDeferredHint: "Ödeme henüz alınmadı, sadece vade tarihi kaydedilir. Tahsil edildiğinde 'Tahsil Et' butonuyla kapatırsın.",
                dueDate: "Vade Tarihi",
                note: "Açıklama",
                notePlaceholder: "İsteğe bağlı açıklama",
                installmentNo: "{no}. Taksit",
                paymentStatus: {
                    0: "Bekliyor",
                    1: "Tamamlandı",
                    2: "Başarısız",
                    3: "İade Edildi",
                },
                methodCode: {
                    CASH: "Nakit",
                    CREDIT_CARD: "Kredi Kartı",
                    INSTALLMENT: "Elden Taksit",
                    ONLINE: "Online Ödeme",
                    BANK_TRANSFER: "Banka Havalesi",
                },
            },
            installment: {
                title: "Taksit Planı",
                create: "Taksit Planı Oluştur",
                createTitle: "Taksit Planı Oluştur",
                count: "Taksit Sayısı",
                countHint: "2 ile 48 arasında bir değer girin.",
                startDate: "İlk Vade",
                startDateHint: "Verilmezse bir ay sonra başlar.",
                perInstallment: "Taksit başına",
                lastInstallmentDiff: "Son taksite kuruş farkı eklenir.",
                preview: "Önizleme",
                remaining: "Kalan tutar",
                onlyIncome: "Taksit planı sadece tahsilat işlemlerinde oluşturulabilir.",
                planExists: "Bu işleme zaten taksit planı kurulmuş.",
                noRemaining: "Tüm tutar ödenmiş, taksit planı kurulamaz.",
            },
            alerts: {
                overPaid: "Fazla ödeme: {amount}. Kasaya iade için bir REFUNDED ödeme kaydı ekleyin.",
                moduleLocked: "Bu tahsilat bir modülden açıldığı için bu sayfadan silinemez.",
                paymentMethodLocked: "Modülün desteklemediği yöntem seçildiğinde sistem hata verir.",
                pendingInstallment: "Vadesi gelmiş taksitler için sağdan 'Tahsil Et' kullanın.",
            },
            confirm: {
                deletePaymentTitle: "Ödemeyi sil?",
                deletePaymentDesc: "Bu işlem geri alınamaz, ilgili tahsilat durumu otomatik güncellenir.",
                deleteTransactionTitle: "Tahsilat kaydını sil?",
                deleteTransactionDesc: "Tüm ödeme kayıtları da silinir.",
            },
            errors: {
                validate_error: "Eksik veya hatalı alan var, lütfen kontrol edin.",
                record_not_found: "Kayıt bulunamadı.",
                payment_method_id_required_when_paid_amount: "Tahsil edilecek tutar için ödeme yöntemi seçin.",
                cannot_delete_module_transaction: "Modülden açılmış tahsilat bu sayfadan silinemez.",
                remaining_payment_exists: "Tüm tahsilat tamamlanmadan kapanış yapılamaz.",
                invalid_transaction_id: "İlgili tahsilat kaydı bulunamadı.",
                invalid_payment_method_id: "Geçersiz ödeme yöntemi.",
                payment_method_not_available_for_transaction: "Bu ödeme yöntemi tahsilat işlemlerinde kullanılamıyor.",
                module_does_not_support_transactions: "İlgili modül tahsilat işlemini desteklemiyor.",
                unsupported_payment_method: "Bu ödeme yöntemi seçili modül için geçerli değil.",
                invalid_cash_register_id: "Seçili kasa bu şirkete ait değil.",
                no_cash_register: "Tahsil edilecek bir kasa belirtilmedi ve varsayılan kasa tanımlı değil.",
                payment_exceeds_total_amount: "Bu tutar toplam tahsilat tutarını aşıyor.",
                installment_only_for_income: "Taksit planı sadece tahsilat işlemlerinde kurulabilir.",
                invalid_installment_count: "Taksit sayısı 2 ile 48 arasında olmalı.",
                installment_payment_method_not_found: "Sistem üzerinde 'Elden Taksit' yöntemi tanımlı değil.",
                no_remaining_amount: "Kalan tutar yok, taksit planı kurulamaz.",
                at_least_one_default_cash_register_required: "Şirkette en az bir varsayılan kasa olmalı.",
                cannot_delete_last_cash_register: "Şirketin son kasası silinemez.",
                generic: "İşlem tamamlanamadı, lütfen tekrar deneyin.",
            },
            actions: {
                openPayments: "Ödemeler",
                refresh: "Yenile",
                detailedManage: "Detaylı Yönet",
            },
            badge: {
                modulePill: "Modül",
                manualPill: "Manuel",
            },
        },
    },
    menu: {
        chooseCompanySelect: 'Şirket Seç',
        accountManagement: "Hesap Yönetimi",
        customerManagement: "Müşteri Yönetimi",
        moduleManagement: "Modül Yönetimi",
        financialManagement: "Finansal İşlemler",

        dashboard: "Gösterge Paneli",
        customerList: "Müşteriler",
        customerAdd: "Müşteri Ekle",
        stockList: "Ürünler",
        category: "Kategoriler",
        warehouse: "Depolar",
        warehouseShelf: "Raflar",
        cashRegister: "Kasa",
        transaction: "Tahsilatlar",

        userList: "Kullanıcılar",
        companyList: "Şirketler",
        productList: "Ürünler",
        modules: "Modüller",
        allModules: "Tüm Modüller",
        VEHICLE_WORK_ORDER: "Araç İş Emri",
        vehicleWorkOrder: "Dashboard",
        vehicleWorkOrderAdd: "Yeni İşlem",
        vehicleWorkOrderList: "Tüm İşlemler",
        vehicleWorkOrderOpen: "Açık İşlemler",
        vehicleWorkOrderOngoing: "Devam Eden İşlemler",
        vehicleWorkOrderCompleted: "Tamamlanan İşlemler",
        NETGSM: 'NetGSM',
        NOTE: 'Notlar',
        noteApp: 'Notlar',
        AGENDA: 'Ajanda',
        agendaApp: 'Ajanda',
        WEATHER: 'Hava Durumu',
        weatherPanel: 'Hava Durumu',
        FILE_MANAGER: 'Dosya Yöneticisi',
        fileManagerPanel: 'Dosya Yöneticisi',
        MUSIC: 'Müzik',
        musicPanel: 'Müzik',
        BILLING: 'Abonelik',
        billingPanel: 'Abonelik',
    },
    pages: {
        customerTransaction: {
            title: "Müşteri Tahsilatları",
            customerInfo: "Müşteri",
            summaryTitle: "Hesap Özeti",
            backToCustomer: "Müşteri Detayına Dön",
        },
        transaction: {
            title: "Tahsilatlar",
            subTitle: "Şirket tahsilat ve ödemelerinin merkezi listesi. Modülden açılan tahsilatlar ve manuel kayıtların hepsi burada görüntülenir.",
            newTitle: "Manuel Tahsilat Oluştur",
            newDescription: "Modülden bağımsız bir tahsilat veya ödeme kaydı oluşturur.",
            cols: {
                id: "ID",
                direction: "Yön",
                source: "Kaynak",
                target: "Taraf",
                total: "Toplam",
                paid: "Ödenen",
                remaining: "Kalan",
                status: "Durum",
                createdAt: "Tarih",
                amounts: "Tutarlar",
            },
            filter: {
                direction: "Yön",
                status: "Durum",
                source: "Kaynak",
                allDirections: "Tümü",
                allStatuses: "Tümü",
                onlyManual: "Sadece manuel",
                onlyModule: "Sadece modül",
            },
            empty: "Henüz tahsilat kaydı bulunmuyor.",
            target: {
                COMPANY_CUSTOMER: "Müşteri",
                manualNote: "Manuel",
                noTarget: "—",
            },
        },
        login: {
            title: "Şirket Paneli",
            cols: {
                email: "E - Posta",
                password: "Şifre"
            },
            successLogin: "Başarıyla giriş yaptınız!",
            btnText: "Giriş Yap",
            responseMessages: {
                invalidCredentials: "E - Posta veya Şifre yanlış!",
                forbiddenRequest: "Giriş işlemi başarısız. Lütfen IP adresinizin izinli olduğundan emin olunuz!"
            }
        },
        dashboard: {
            title: "Lütfen sol menüden yapmak istediğiniz işlemi seçiniz.",
            customer: {
                title: "Müşteriler",
            }
        },
        account: {
            overview: {
                title: "Profil Detayları",
                cols: {
                    name: "Ad",
                    surname: "Soyad",
                    email: "E - Posta",
                    phone: "Telefon",
                }
            },
            settings: {
                signInMethod: {
                    title: "Oturum Açma Yöntemi",
                    emailAddress: "E - Posta Adresi",
                    password: {
                        title: "Şifre",
                        cols: {
                            currentPassword: "Şuanki Şifre",
                            password: "Şifre",
                            passwordConfirmation: "Şifre Tekrar",
                        },
                        changePassword: "Şifre Değiştir",
                        updatePassword: "Şifreyi Güncelle",
                        responseMessages: {
                            currentPasswordInvalid: "Şuanki şifre geçersiz."
                        }
                    }
                }
            }
        },
        customer: {
            title: "Müşteriler",
            subTitle: "Müşteri Listesi",
            cols: {
                id: "ID",
                customer: "Müşteri",
                firstname: "Ad",
                lastname: "Soyad",
                mobilePhone: "Telefon",
                email: "E-Posta Adresi",
                active: "Durum",
            },
            newCustomer: "Yeni Müşteri Ekle",
            editCustomerPattern: "Müşteri Düzenle - %s",
            detailCustomer: "Müşteri Detayı - %s",
            detail: {
                user: {
                    title: "Kişisel Bilgiler",
                },
                vehicle: {
                    title: "Kayıtlı Araçlar",
                    brand: "Marka",
                    model: "Model",
                    year: "Model Yılı",
                    notFound: "Tanımlı araç bulunmamaktadır",
                    link: {
                        VEHICLE_WORK_ORDER: "Araca Yapılan İşlemler"
                    },
                },
                module: {
                    title: "Hizmet Aldığı Modüller",
                    notFound: "Tanımlı modül bulunmamaktadır",
                    link: {
                        VEHICLE_WORK_ORDER: "Kullanıcıya ait iş emirleri"
                    },
                },
            }
        },
        cash_register: {
            title: "Kasalar",
            subTitle: "Şirket kasalarının listesi. Varsayılan kasa ve bakiye bilgileri burada görüntülenir.",
            cols: {
                id: "ID",
                name: "Ad",
                balance: "Bakiye",
                isDefault: "Varsayılan",
                netBalance: "Net Bakiye",
                manualBalance: "Manuel Bakiye",
                income: "Tahsilat (Gelir)",
                expense: "Ödeme (Gider)",
                manualIn: "Manuel Giriş",
                manualOut: "Manuel Çıkış",
            },
            newCash: "Yeni Kasa Ekle",
            editCashPattern: "Kasa Düzenle - %s",
            detailCash: "Kasa Detayı - %s",
            defaultBadge: "Varsayılan",
            setAsDefault: "Varsayılan Yap",
            defaultLocked: "Tek kasa varsayılan dışı yapılamaz.",
            cannotDeleteLast: "Son kasa silinemez.",
            confirmDeleteHint: "Bu kasaya bağlı geçmiş hareketler korunur ama listede artık görünmez.",
            detail: {
                title: "Kasa Detayı",
                balanceTitle: "Bakiye Özeti",
                transactionsTab: "Tahsilatlardan",
                manualTab: "Manuel Hareketler",
                netBalanceLabel: "Net Bakiye",
                netBalanceHint: "Tahsilat ödemeleri + manuel hareketler birlikte hesaplanır.",
                manualBalanceHint: "Sadece manuel girilen hareketlerin neti.",
            },
            movement: {
                title: "Manuel Hareketler",
                subTitle: "Kasaya elden eklenen veya çıkarılan tutarların geçmişi.",
                empty: "Henüz manuel hareket kaydı yok.",
                add: "Yeni Hareket",
                addTitle: "Yeni Manuel Hareket",
                direction: "Yön",
                directionType: {
                    1: "Giriş",
                    2: "Çıkış",
                },
                directionAll: "Tümü",
                amount: "Tutar",
                amountPlaceholder: "0,00",
                note: "Açıklama",
                notePlaceholder: "Hareket açıklaması (opsiyonel)",
                createdAt: "Tarih",
                auditNote: "Manuel hareketler kayıt sonrası düzenlenemez veya silinemez. Düzeltme gerekiyorsa ters yönde yeni bir hareket ekleyin.",
                cols: {
                    direction: "Yön",
                    amount: "Tutar",
                    note: "Açıklama",
                    createdAt: "Tarih",
                },
                filter: {
                    direction: "Yön",
                    createdAtMin: "Tarih (Başlangıç)",
                    createdAtMax: "Tarih (Bitiş)",
                },
            },
        },
        stock: {
            title: "Ürünler",
            subTitle: "Ürün Listesi",
            cols: {
                id: "ID",
                name: "Ad",
                code: "Stok Kodu",
                category: "Kategori",
                sale_price: "Satış Fiyatı",
                current_quantity: "Mevcut Stok",
                total_quantity: "Toplam Stok",
                unit: "Birim",
                active: "Durum",
                min_quantity: "Minimum Stok",
            },
            lowStockBadge: "Düşük Stok",
            newStock: "Yeni Ürün Ekle",
            editStockPattern: "Ürün Düzenle - %s",
            detailStock: "Ürün Detayı - %s",
            detail: {
                title: "Stok Detayı",
                infoTitle: "Stok Bilgisi",
                infoTab: "Bilgi",
                locationsTab: "Depolar",
                movementsTab: "Hareketler",
                noLocationsHint: "Bu ürün hiçbir depoya henüz eklenmemiş. Sağdan yeni depo ekleyin.",
                noMovementsHint: "Bu ürün için henüz hareket kaydı yok.",
                editStock: "Ürünü Düzenle",
            },
            location: {
                title: "Depolar",
                add: "Depo Ekle",
                addTitle: "Yeni Depoya Ekle",
                addHint: "Bu ürünü hangi depoya kaydetmek istediğinizi seçin.",
                warehouse: "Depo",
                warehousePlaceholder: "Depo seçin",
                currentQuantity: "Mevcut Miktar",
                delete: "Bu Depodan Çıkar",
                confirmDelete: "Bu lokasyon kaydı silinecek. Stok miktarı 0 olmalıdır.",
                emptyHint: "Stoğu depolara dağıtarak bakiyeyi takip edin.",
                allWarehousesUsed: "Bu ürün tüm depolara eklenmiş, eklenebilecek başka depo yok.",
                quickAdd: "Stok Gir",
                quickRemove: "Stok Çıkar",
                expense: "Kasaya Gider",
                expenseTooltip: "Bu hareket kasaya otomatik gider olarak işlendi.",
            },
            movement: {
                title: "Hareketler",
                add: "Hareket Ekle",
                addTitle: "Yeni Stok Hareketi",
                transfer: "Depolar Arası Transfer",
                transferTitle: "Depolar Arası Transfer",
                type: "Hareket Tipi",
                typeLabel: {
                    1: "Giriş",
                    2: "Çıkış",
                    3: "Düzeltme",
                },
                location: "Lokasyon",
                locationPlaceholder: "Lokasyon seçin",
                quantity: "Miktar",
                quantityPlaceholder: "0,00",
                unitPrice: "Birim Fiyat",
                isExpense: "Kasaya Gider Olarak İşle",
                isExpenseHint: "Açık olduğunda otomatik kasa çıkışı (EXPENSE) oluşur.",
                paymentMethod: "Ödeme Yöntemi",
                cashRegister: "Kasa",
                cashRegisterDefault: "(Varsayılan)",
                note: "Açıklama",
                notePlaceholder: "İsteğe bağlı açıklama",
                adjustmentWarn: "Düzeltme hareketleri silinemez, kayıt audit için saklanır.",
                deleteHint: "Hareketi silmek lokasyondaki stok miktarını geri alır. İlişkili kasa kaydı varsa iade edilir.",
                deleteAdjustment: "Düzeltme hareketleri silinemez.",
                cols: {
                    date: "Tarih",
                    type: "Tip",
                    location: "Lokasyon",
                    quantity: "Miktar",
                    unitPrice: "Birim Fiyat",
                    note: "Açıklama",
                },
                from: "Kaynak Depo",
                to: "Hedef Depo",
                allowNegative: "Negatif Stoğa İzin Ver",
                allowNegativeHint: "Kaynak depoda yeterli stok yoksa transfer yine de yapılır, miktar negatife düşebilir.",
                stockInSource: "Kaynak depoda mevcut: {amount}",
                stockInTarget: "Hedef depoda mevcut: {amount}",
                source: {
                    MODULE_VEHICLE_WORK_ORDER_ITEM: "Araç İş Emri Kalemi",
                    TRANSFER: "Transfer",
                },
            },
            errors: {
                stock_code_already_exists: "Bu stok kodu zaten kullanımda.",
                cannot_delete_location_with_stock: "Bu lokasyonda hala stok var. Önce başka depoya transfer edin veya sıfırlayın.",
                at_least_one_default_warehouse_required: "Şirkette en az bir varsayılan depo olmalı.",
                cannot_delete_last_warehouse: "Şirketin son deposu silinemez.",
                warehouse_has_stock_locations: "Bu depoda stok lokasyonları var. Önce stokları başka depoya taşıyın.",
                adjustment_movement_cannot_be_deleted: "Düzeltme hareketleri silinemez.",
                module_only_for_root_category: "Modül sadece ana kategorilere atanabilir.",
                invalid_stock_location_id: "Lokasyon bu stoğa ait değil.",
                location_already_exists: "Bu stok zaten bu depoda mevcut.",
                circular_category_reference: "Kategori döngüsel referans oluşturuyor.",
                category_tree_has_stocks: "Kategori ağacında stok kayıtları var. Önce stokları taşıyın veya silin.",
                insufficient_stock: "Kaynak depoda yeterli stok yok.",
                cannot_transfer_to_same_warehouse: "Aynı depoya transfer yapılamaz.",
                stock_not_in_source_warehouse: "Stoğun kaynak depoda lokasyonu yok.",
                invalid_from_warehouse_id: "Geçersiz kaynak depo.",
                invalid_to_warehouse_id: "Geçersiz hedef depo.",
                invalid_warehouse_id: "Geçersiz depo.",
                invalid_stock_category_id: "Geçersiz stok kategorisi.",
                invalid_module_id: "Modül bu şirkette aktif değil.",
                invalid_parent_id: "Geçersiz üst kategori.",
                category_cannot_be_its_own_parent: "Kategori kendisinin üst kategorisi olamaz.",
                invalid_stock_id: "Geçersiz stok kaydı.",
                invalid_unit_id: "Geçersiz birim.",
                no_cash_register: "Varsayılan kasa tanımlı değil. Lütfen bir kasa seçin veya tanımlayın.",
            },
            save: {
                title: "Ürün Bilgileri",
                codePlaceholder: "Boş bırakılırsa otomatik kod oluşturulur",
                minQuantityPlaceholder: "Düşük stok uyarısı için eşik",
                cols: {
                    name: "Ad",
                    code: "Barkod",
                    category: "Kategori",
                    unit_type: "Birim",
                    warehouse: "Depo",
                    shelf: "Depo Rafı",
                    min_quantity: "Minimum Stok",
                    min_quantity_description: "Stok miktarı belirtilen miktarın altına düştüğü takdirde bilgilendirileceksiniz.",
                    sale_price: "Satış Fiyatı"
                }
            },
            category: {
                title: "Kategoriler",
                subTitle: "Stok kategori ağacını yönetin",
                module_description: "Bu kategoriyi kullanabilecek modülleri seçebilirsiniz, tüm modüller tarafından kullanılabilmesi için boş bırakın.",
                cols: {
                    id: "ID",
                    name: "Ad",
                    module: "Kategoriyi Kullanacak Modüller"
                },
                newCategory: "Yeni Kategori Ekle",
                newCategoryWithParent: "%s Kategorisine Alt Kategori Ekle",
                editCategoryPattern: "Kategori Düzenle - %s",
                detailCategory: "Kategori Detayı - %s",
                searchPlaceholder: "Kategori ara...",
                expandAll: "Tümünü Aç",
                collapseAll: "Tümünü Kapat",
                addRoot: "Yeni Ana Kategori",
                addSub: "Alt Kategori Ekle",
                rootBadge: "Ana",
                subCountPattern: "%s alt",
                emptyTitle: "Henüz kategori yok",
                emptyDesc: "Stoklarınızı gruplamak için ilk kategoriyi oluşturun.",
                emptyCta: "İlk Kategoriyi Ekle",
                noSearchResultPattern: "\"%s\" ile eşleşen kategori bulunamadı",
                clearSearch: "Aramayı temizle",
                deleteConfirmLeaf: "\"%s\" kategorisi silinecek. Devam edilsin mi?",
                deleteConfirmTree: "\"%s\" ve altındaki %s kategori birlikte silinecek. Bu işlem geri alınamaz.",
                nameLabel: "Kategori Adı",
                namePlaceholder: "Örn. Motor Yağları",
                rootContext: "Ana kategori oluşturuluyor",
                subContext: "%s altına ekleniyor",
                detail: {}
            },
            warehouse: {
                title: "Depolar",
                subTitle: "Depo Listesi",
                cols: {
                    id: "ID",
                    name: "Ad",
                    is_default: "Varsayılan",
                    shelves_count: "Raf Sayısı",
                    active: "Durum",
                },
                newWarehouse: "Yeni Depo Ekle",
                editWarehouse: "Depo Düzenle",
                editWarehousePattern: "Depo Düzenle - %s",
                detailWarehouse: "Depo Detayı - %s",
                shelf: {
                    title: "Raflar",
                    subTitle: "Raf Listesi",
                    cols: {
                        id: "ID",
                        name: "Ad",
                        active: "Durum",
                    },
                    newShelf: "Yeni Raf Ekle",
                    editShelf: "Raf Düzenle",
                    editShelfPattern: "Raf Düzenle - %s",
                    detailShelf: "Raf Detayı - %s",
                }
            },
        },
        module: {
            title: "Modüller",
            subTitle: "Modül Listesi",
            status: {
                inactive: "Pasif",
                expired: "Süresi Doldu",
            },
            statusInfo: {
                inactive: "Bu modül pasif durumda. Yöneticinizle iletişime geçin.",
                expired: "Aboneliğiniz sona erdi.",
            },
            expiredDialog: {
                title: "Modül Aboneliği Sona Ermiş",
                message: "Bu modülün aboneliği sona ermiş durumda. Tekrar erişim sağlamak için aboneliğinizi yenilemeniz gerekiyor.",
                ok: "Tamam",
            },
            credentials: {
                title: "Kimlik Bilgileri",
                subTitle: "%s - Kimlik Bilgileri",
            },
            settings: {
                title: "Ayarlar",
                subTitle: "%s - Ayarları",
                tooltip: {
                    enabledSms: "Müşteriye SMS gönderimini aç/kapat"
                }
            },
            VEHICLE_WORK_ORDER: {
                title: "Araç İş Emri",
                subTitle: "Daha önceden açılmış olan işlem kayıtlarının listesi",
                description: "Daha önceden açmış olduğunuz tüm işlemleri bu sayfa üzerinden listeleyebilir, tercihinize göre filtreleyebilir ve görüntüleyebilirsiniz.",
                newItem: "Yeni İş Emri Ekle",
                editItemPattern: "İş Emri Düzenle - %s",
                statusChange: "Durum Değiştir",
                detailTitle: "%s - İş Emri Kaydı Detayı",
                cols: {
                    id: "ID",
                    statusId: "Durum",
                    status: {
                        1: "AÇIK",
                        2: "İŞLEMDE",
                        3: "TAMAMLANDI",
                        4: "TEDARİK BEKLENİYOR",
                        5: "İPTAL EDİLDİ",
                        6: "PARA İADESİ YAPILDI",
                    },
                    priceContainer: "Toplam / Ödenen",
                    totalPrice: "Toplam Fiyat",
                    totalPaid: "Ödenen",
                    typeName: "Tip",
                    user: "Müşteri",
                    mobilPhone: "Tel: %s",
                    customerCar: "Araç Bilgisi",
                    plate: "Plaka",
                    updatedAt: "Düzenlenme Tarihi",
                    createdAt: "Eklenme Tarihi",
                },
                status: {
                    1: {
                        title: "Açık Olan İşlemler",
                        description: "Henüz herhangi bir işleme alınmamış, planlama veya başlatılmayı bekleyen iş emirlerini ifade eder.",
                    },
                    2: {
                        title: "İşlemde Olan İşlemler",
                        description: "Aktif olarak üzerinde çalışılan, işçilik, parça kullanımı veya operasyonel süreci devam eden iş emirleridir.",
                    },
                    3: {
                        title: "Tamamlanan İşlemler",
                        description: "Tüm operasyonları başarıyla tamamlanmış, kapatılmış ve raporlamaya hazır iş emirlerini kapsar.",
                    },
                    4: {
                        title: "Tedarik Bekleyen İşlemler",
                        description: "Gerekli parça veya malzeme temini beklenen, bu nedenle operasyon süreci geçici olarak durdurulmuş iş emirleri listelenir.",
                    },
                    5: {
                        title: "İptal Edilen İşlemler",
                        description: "Herhangi bir nedenle devam ettirilmeyen, operasyon süreci sonlandırılmış ve sistem üzerinde kapatılmış iş emirleri yer alır.",
                    },
                    6: {
                        title: "Para İadesi Yapılan İşlemler",
                        description: "Ücret iadesi gerçekleştirilmiş, finansal süreçleri tamamlanmış ve kayıt altına alınarak kapatılmış iş emirleri gösterilir.",
                    },
                },
                type: {
                    title: "İşlem Tipleri",
                    subTitle: "İşlem Tipi Listesi",
                    description: "İş süreçlerinde kullanılan işlem tipleri tanımlanır, düzenlenir ve süreçlerin sistematik şekilde yönetilmesi sağlanır.",
                    newItem: "Yeni İş Emir Türü Ekle",
                    editItemPattern: "İş Emir Türü Düzenle - %s",
                    cols: {
                        id: "ID",
                        name: "Başlık",
                        description: "Tanım",
                    }
                },
                item: {
                    newItem: "İşlem Ekle",
                    emptyItemAlert: {
                        title: "İşlem Bulunamadı",
                        message: "İş emriyle ilgili yapılacak işlemlerin kayıt altına alınabilmesi için en az bir işlem kalemi tanımlanması gerekmektedir."
                    },
                    editItemPattern: "İşlem Düzenle - %s",
                    cols: {
                        id: "ID",
                        quantity: "Adet",
                        title: "Başlık",
                        price: "Fiyat",
                    }
                },
                save: {
                    title: "İşlem Ekle",
                    description: "Yeni iş emirleri oluşturulur, ilgili işçilik, parça ve operasyon bilgileri tanımlanarak süreçlerin sistem üzerinden başlatılması sağlanır.",
                    priceAlert: {
                        paidExact: "Ödeme tutarı, toplam tutarla eşleşmektedir.",
                        paidOver: "Girilen ödeme tutarı, toplam tutardan %s ₺ fazladır.",
                        paidUnder: "Girilen ödeme tutarı, toplam tutardan %s ₺ eksiktir."
                    },
                    payment: {
                        initialTitle: "İlk Tahsilat",
                        initialHint: "Boş bırakırsan kayıt sonrası ödeme eklenmez. Tutar girersen 'şimdi tahsil edildi' olarak işlenir, kasaya gelir yazılır.",
                    },
                    fastSearch: {
                        title: "Hızlı Araç Arama",
                        placeholder: "Müşteri ad/soyad verisi, telefon numarası veya plaka ile arama yapar",
                        resetButton: "Sıfırla",
                        registeredVehicle: "Kayıtlı Araçlar",
                        registeredVehicleDescription: "Sistemde kayıtlı araçları seçerek bilgileri doldurabilirsiniz."
                    },
                    customer: {
                        title: "Müşteri Bilgileri",
                        newUser: "Yeni Müşteri",
                        registeredUser: "Kayıtlı Müşteri",
                        registeredUserDescription: "Kayıtlı Müşterileri seçerek bilgileri doldurabilirsiniz.",
                        cols: {
                            firstname: "Ad",
                            lastname: "Soyad",
                            mobilePhone: "Telefon",
                            customerSelect: "Müşteri Seç",
                        }
                    },
                    vehicle: {
                        title: "Araç Bilgileri",
                        newCar: "Yeni Araç",
                        registeredVehicle: "Kayıtlı Araçlar",
                        historyVehicleWorkOrder: {
                            title: "Geçmiş Tarihli İşlemler",
                            btn: "Geçmiş İşlemler",
                        },
                        cols: {
                            brand_model: "Marka & Model",
                            brand: "Marka",
                            model: "Model",
                            year: "Model Yılı",
                            plate: "Plaka",
                            odometer: "Kilometre",
                            carSelect: "Araç Seç",
                        }
                    },
                    items: {
                        title: "İşlem Bilgileri",
                        subTitle: "İşlem Kayıtları",
                        cols: {
                            quantity: "Adet",
                            title: "Başlık",
                            price: "Fiyat",
                            unit: "Birim",
                            stockLocation: "Depo Konumu",
                            stockSearchPlaceholder: "Stok ara veya serbest metin girin...",
                            stockSearch: {
                                searching: "Aranıyor...",
                                noResults: "Sonuç bulunamadı",
                                stock: "Stok",
                            },
                        }
                    },
                    notes: {
                        title: "Notlar",
                        cols: {
                            id: "ID",
                            title: "Başlık",
                            content: "İçerik",
                        }
                    },
                    cols: {
                        id: "ID",
                        type: "İşlem Tipi",
                        statusId: "Durum",
                        priceTypeId: "Fiyat Hesaplaması",
                        priceTypeIdSubTitle: "Fiyatlandırmanın nasıl yapılacağını seçin. Otomatik, işlem kayıtları bazlı girilen fiyatlar sistem tarafından toplanarak toplam tutar oluşturulur. Manuel ise işlem kayıtlarında fiyat girilmez, toplam tutar doğrudan kullanıcı tarafından belirlenir.",
                        priceType: {
                            itemBased: "Otomatik",
                            orderBased: "Manuel",
                        },
                        totalPrice: "Toplam Fiyat",
                        totalPaid: "Ödenen Fiyat",
                        complaint: "Şikayet",
                        diagnosis: "Teşhis",
                    },
                    images: {
                        title: "Görseller",
                        empty: "Görsel eklemek için tıklayın",
                        manage: "Yönet",
                    },
                },
                alert: {
                    not_found_complaint: "Bu iş emri için şikayet bilgisi bulunamadı.",
                    not_found_diagnosis: "Bu iş emri için teşhis bilgisi bulunamadı.",
                }
            },
            AGENDA: {
                title: 'Ajanda',
                description: "Takvim tabanlı etkinlik yönetimi ile toplantılarınızı, görevlerinizi ve hatırlatıcılarınızı planlayın.",
                panel: {
                    title: 'Ajanda',
                    monthView: 'Ay',
                    dayView: 'Gün',
                    today: 'Bugün',
                    newEvent: 'Yeni',
                    refresh: 'Yenile',
                    center: 'Ortala',
                    floatingMode: 'Serbest Mod',
                    close: 'Kapat',
                    sidebar: 'Kenar çubuğu',
                    noEvents: 'Bu gün için etkinlik yok',
                    addEvent: '+ Etkinlik Ekle',
                    more: 'daha',
                    morning: 'Öğleden Önce',
                    afternoon: 'Öğleden Sonra',
                    groupByTime: 'Zamana göre grupla',
                    allDay: 'Tüm gün',
                    showShared: 'Paylaşılanlar',
                },
                form: {
                    newEvent: 'Yeni Etkinlik',
                    editEvent: 'Etkinlik Düzenle',
                    viewEvent: 'Etkinlik Detayı',
                    title: 'Başlık',
                    titlePlaceholder: 'Etkinlik başlığı',
                    description: 'Açıklama',
                    descriptionPlaceholder: 'Açıklama (opsiyonel)',
                    color: 'Renk',
                    eventDate: 'Etkinlik Tarihi',
                    eventDatePlaceholder: 'Tarih ve saat seçin',
                    reminder: 'Hatırlatıcı',
                    reminderPlaceholder: 'Opsiyonel',
                    visibility: 'Görünürlük',
                    visibilityOnlyMe: 'Sadece Ben',
                    visibilityCompany: 'Tüm Şirket',
                    visibilityGroup: {
                        company: 'Tüm Şirket',
                        admin: 'Tüm Yöneticiler',
                    },
                    visibilitySelected: 'Seçili Kişiler',
                    viewers: 'Görüntüleyiciler',
                    viewersPlaceholder: 'Kişi seçin',
                    save: 'Kaydet',
                    saving: 'Kaydediliyor...',
                    cancel: 'İptal',
                    titleRequired: 'Başlık zorunludur',
                    dateRequired: 'Etkinlik tarihi zorunludur',
                    viewerRequired: 'En az bir görüntüleyici seçmelisiniz',
                    saveError: 'Kaydetme hatası',
                    eventEndDate: 'Bitiş Tarihi',
                    eventEndDatePlaceholder: 'Opsiyonel',
                    endMustBeAfterStart: 'Bitiş tarihi başlangıçtan sonra olmalıdır',
                },
                contextMenu: {
                    edit: 'Düzenle',
                    addReminder: 'Hatırlatıcı Ekle',
                    editReminder: 'Hatırlatıcıyı Düzenle',
                    editReminders: 'Hatırlatıcıları Düzenle',
                    removeReminder: 'Hatırlatıcıyı Kaldır',
                    removeReminders: 'Hatırlatıcıları Kaldır',
                    markCompleted: 'Tamamlandı Olarak İşaretle',
                    markPending: 'Beklemede Olarak İşaretle',
                    delete: 'Sil',
                    deleteConfirm: 'Bu etkinliği silmek istediğinizden emin misiniz?',
                    deleteTitle: 'Etkinliği Sil?',
                    deleteMessage: 'Bu işlem geri alınamaz.',
                    cancel: 'Vazgeç',
                },
                reminder: {
                    add: 'Hatırlatıcı Ekle',
                    edit: 'Hatırlatıcı Düzenle',
                    addReminder: 'Yeni Hatırlatıcı Ekle',
                    typeBefore: 'Hızlı Seçim',
                    customDate: 'Özel Tarih',
                    noReminders: 'Henüz hatırlatıcı eklenmedi',
                    remove: 'Kaldır',
                    minutesBefore: '{n} dakika önce',
                    hoursBefore: '{n} saat önce',
                    daysBefore: '{n} gün önce',
                    reminders: 'Hatırlatıcılar',
                    time: 'Hatırlatıcı Zamanı',
                    timePlaceholder: 'Hatırlatıcı tarihi seçin',
                    required: 'Hatırlatıcı zamanı zorunludur',
                    mustBeFuture: 'Hatırlatıcı gelecekte olmalıdır',
                    mustBeBeforeEvent: 'Hatırlatıcı etkinlik tarihinden önce olmalıdır',
                    save: 'Kaydet',
                    cancel: 'İptal',
                },
                recurrence: {
                    title: 'Bu etkinliği tekrarla',
                    frequency: 'Sıklık',
                    every: 'Her',
                    daily: 'Gün',
                    weekly: 'Hafta',
                    monthly: 'Ay',
                    yearly: 'Yıl',
                    interval: 'Aralık',
                    endType: 'Bitiş',
                    indefinite: 'Süresiz',
                    untilDate: 'Tarihe kadar',
                    afterCount: 'Tekrar sayısı',
                    times: 'kez',
                    repeatEvery: 'Etkinlik her {freq} tekrarlanır',
                    repeatEveryN: 'Etkinlik {n} {freq} arayla tekrarlanır',
                    endNever: 'Süresiz devam eder',
                    endOnDate: '{date} tarihine kadar devam eder',
                    endAfterN: '{n} {freq} sonra sona erer',
                },
                scope: {
                    updateTitle: 'Tekrarlayan etkinliği düzenle',
                    updateMessage: 'Bu değişiklik hangi etkinliklere uygulanacak?',
                    deleteTitle: 'Tekrarlayan etkinliği sil',
                    deleteMessage: 'Hangi etkinlikler silinsin?',
                    thisOnly: 'Yalnızca Bu Etkinlik',
                    thisAndFuture: 'Bu ve Sonrakiler',
                    all: 'Tümüne',
                    realignTitle: 'Tarihler nasıl hizalansın?',
                    realignMessage: 'Diğer etkinliklerin tarih hizalamasının nasıl uygulanması gerektiğini seçin.',
                    realignShift: 'Kaydır',
                    realignShiftDesc: 'Yapılan değişiklik kadar diğer etkinlikler de kaydırılır',
                    realignAlign: 'Hizala',
                    realignAlignDesc: 'Tüm etkinlikler yeni tarihe göre hizalanır',
                },
                status: {
                    pending: 'Bekliyor',
                    completed: 'Tamamlandı',
                },
                colors: {
                    red: 'Kırmızı',
                    orange: 'Turuncu',
                    yellow: 'Sarı',
                    green: 'Yeşil',
                    blue: 'Mavi',
                    purple: 'Mor',
                    pink: 'Pembe',
                    gray: 'Gri',
                },
            },
            NETGSM: {
                title: 'NetGSM',
                description: "NetGSM SMS sağlayıcısı entegrasyonu sayesinde sistem üzerinden SMS gönderimleri yönetilir, teslimat durumları izlenir ve raporlanır.",
            },
            VERIMOR: {
                title: 'Verimor',
                description: "Verimor SMS sağlayıcısı entegrasyonu sayesinde sistem üzerinden SMS gönderimleri yönetilir, teslimat durumları izlenir ve raporlanır.",
            },
            WEATHER: {
                title: 'Hava Durumu',
                description: "Şehirleriniz için anlık hava durumu, saatlik ve haftalık tahminleri takip edin.",
            },
            MUSIC: {
                title: 'Müzik',
                description: "Binlerce radyo istasyonunu dinleyin, kendi çalma listelerinizi oluşturun ve çalışırken müziğin keyfini çıkarın.",
            },
            NOTE: {
                title: 'Notlar',
                description: "Notlarınızı kategoriler ve etiketlerle düzenleyin, paylaşın ve her cihazdan erişin.",
                sidebar: {
                    all: 'Tüm Notlar',
                    includeShared: 'Paylaşılanları dahil et',
                    sharedWithMe: 'Benimle Paylaşılanlar',
                    categories: 'Kategoriler',
                    tags: 'Etiketler',
                    colors: 'Renkler',
                    drafts: 'Taslaklar',
                    trash: 'Çöp Kutusu',
                    newCategory: 'Yeni Kategori',
                    newSubCategory: 'Yeni Alt Kategori',
                    newTag: 'Yeni Etiket',
                    categoryName: 'Kategori adı',
                    tagName: 'Etiket adı',
                    depthLimitTitle: 'Alt Kategori Limiti',
                    depthLimitAdd: 'En fazla 5 seviye alt kategori eklenebilir. Bir üst kategoriye eklemek ister misiniz?',
                    depthLimitMove: 'Toplam 5 seviye limiti aşıldığı için bu işlem tamamlanamıyor.',
                    depthLimitConfirm: 'Ekle',
                    depthLimitCancel: 'Vazgeç',
                },
                list: {
                    search: 'Notlarda ara...',
                    newNote: 'Yeni Not',
                    pinned: 'Sabitlenenler',
                    today: 'Bugün',
                    yesterday: 'Dün',
                    last7Days: 'Son 7 Gün',
                    last30Days: 'Son 30 Gün',
                    empty: 'Henüz not bulunmuyor',
                    emptyDescription: 'Yeni bir not oluşturmak için + butonuna tıklayın.',
                    sharedEmpty: 'Paylaşılan not bulunmuyor',
                    sharedEmptyDescription: 'Sizinle paylaşılan notlar burada görüntülenir.',
                    visibilityCompany: 'Şirketteki Herkes',
                    visibilityGroup: {
                        company: 'Şirketteki Herkes',
                        admin: 'Tüm Yöneticiler',
                    },
                    visibilitySelected: 'Belirli Kişiler',
                    noPreview: 'Başka Metin Yok',
                    draft: 'Taslak',
                    backToList: 'Notlar',
                    notesSelected: 'not seçildi',
                    dragToMove: 'Taşımak için kategoriye sürükleyin',
                },
                editor: {
                    emptyTitle: 'Not Seçilmedi',
                    emptyDescription: 'Bir not seçin veya yeni bir not oluşturun.',
                    color: 'Renk',
                    noColor: 'Renk Yok',
                    category: 'Kategori',
                    noCategory: 'Kategori Yok',
                    tags: 'Etiketler',
                    settings: 'Ayarlar',
                    visibility: 'Görünürlük',
                    visibilityPrivate: 'Sadece Ben',
                    visibilityCompany: 'Şirketteki Herkes',
                    visibilityGroup: {
                        company: 'Şirketteki Herkes',
                        admin: 'Tüm Yöneticiler',
                    },
                    visibilitySelected: 'Belirli Kişiler',
                    visibilityPrivateShort: 'Ben',
                    visibilityCompanyShort: 'Herkes',
                    visibilityGroupShort: {
                        company: 'Herkes',
                        admin: 'Yöneticiler',
                    },
                    visibilitySelectedShort: 'Seçilenler',
                    editPermission: 'Düzenleme Yetkisi',
                    editPermissionOwner: 'Sadece Sahip',
                    editPermissionAll: 'Tüm Görüntüleyenler',
                    editPermissionSelected: 'Belirli Düzenleyiciler',
                    editPermissionOwnerShort: 'Sahip',
                    editPermissionAllShort: 'Herkes',
                    editPermissionSelectedShort: 'Seçilenler',
                    viewers: 'Görüntüleyiciler',
                    editors: 'Düzenleyiciler',
                    revisions: 'Revizyonlar',
                    revisionDetail: 'Düzenleme Geçmişi',
                    revisionTitle: 'Başlık',
                    revisionContent: 'İçerik',
                    revisionBy: '%s tarafından',
                    save: 'Kaydet',
                    pin: 'Sabitle',
                    unpin: 'Sabitlemeyi Kaldır',
                    delete: 'Sil',
                    readOnly: 'Salt Okunur',
                    reminder: 'Ajanda',
                    reminderEventAt: 'Eklenecek Tarih',
                    reminderReminderAt: 'Hatırlatma Tarihi',
                    reminderSave: 'Ekle',
                    reminderDelete: 'Hatırlatıcıyı Kaldır',
                    reminderNoDate: 'Tarih seçiniz',
                    viewerRequired: 'Lütfen en az bir görüntüleyici seçin',
                    editorRequired: 'Lütfen en az bir düzenleyici seçin',
                    uploadingImages: 'Medyalar yükleniyor...',
                    uploadFileCount: '{completed}/{total} dosya',
                    uploadCancel: 'Yüklemeyi İptal Et',
                    uploadErrorTitle: 'Yükleme Hatası',
                    uploadErrorGeneric: 'Dosya yüklenirken bir sorun oluştu. Lütfen tekrar deneyin.',
                },
                contextMenu: {
                    pin: 'Sabitle',
                    unpin: 'Sabitlemeyi Kaldır',
                    moveTo: 'Taşı',
                    duplicate: 'Çoğalt',
                    share: 'Paylaş',
                    delete: 'Sil',
                    rename: 'Adını Değiştir',
                    newSubCategory: 'Yeni Alt Kategori',
                    changeColor: 'Renk Değiştir',
                    uncategorized: 'Kategorisiz',
                },
                trash: {
                    title: 'Çöp Kutusu',
                    empty: 'Çöp kutusu boş',
                    emptyDescription: 'Silinen notlar burada görüntülenir.',
                    restore: 'Kurtar',
                    permanentDelete: 'Kalıcı Sil',
                    permanentDeleteTitle: 'Notu Sil?',
                    permanentDeleteMessage: 'Bu işlem geri alınamaz.',
                    restoreCategoryConfirm: 'Kategoriyi de kurtarmak ister misiniz?',
                    permanentDeleteConfirm: 'Bu işlem geri alınamaz. Notu kalıcı olarak silmek istediğinize emin misiniz?',
                    deletedAt: 'Silinme: %s',
                },
                refresh: 'Yenile',
                floatingMode: 'Yüzer Mod',
                close: 'Kapat',
            }
        },
    },
    filters: {
        title: "Filtre Seçenekleri",
        customer: {
            id: "ID",
            fullName: "Ad & Soyad",
            mobilePhone: "Telefon",
            containingModules: "Sahip Olduğu Modüller",
            active: "Durum",
        },
        module: {
            vehicleWorkOrder: {
                id: "ID",
                user: "Müşteri",
                customerCar: "Müşteri Araçları",
                customerCarPlate: "Araç Plakası",
                customerMobilePhone: "Telefon Numarası",
                status: "Durum",
                companyCustomerId: "Müşteri ID",
                customerVehicleId: "Müşteri Araç ID",
            }
        },
        transaction: {
            id: "ID",
            direction: "Yön",
            status: "Durum",
            source: "Kaynak Modül",
            sourceManual: "Sadece Manuel",
            sourceAny: "Tümü",
            paymentMethod: "Ödeme Yöntemi",
            cashRegister: "Kasa",
            createdAtMin: "Tarih (Başlangıç)",
            createdAtMax: "Tarih (Bitiş)",
        },
    },
    messages: {
        warning: "Uyarı",
        success: "Başarılı",
        error: "Hata",
        sureAction: "İşlemi yapmak istediğinize emin misiniz?",
        sureConfirm: "Onaylamak istediğinize emin misiniz?",
        sureDelete: "Silme işlemi yapmak istediğinize emin misiniz?",
        sureCancel: "İptal işlemi yapmak istediğinize emin misiniz?",
        actionOk: "İşleminiz başarılı bir şekilde tamamlanmıştır.",
        saveOk: "Kayıt başarıyla oluşturuldu.",
        deleteOk: "Silme işleminiz başarılı bir şekilde tamamlanmıştır.",
        cancelOk: "İptal işleminiz başarılı bir şekilde tamamlanmıştır.",
        copyOk: "Kopyalama başarıyla tamamlanmıştır.",
        selectRow: "Lütfen bir kayıt seçiniz!",
        wait: "Lütfen Bekleyiniz!",
        loading: "Yükleniyor",
        noResultFound: "Sonuç bulunamadı!"
    },
    btn: {
        new: "Yeni",
        add: "Ekle",
        create: "Oluştur",
        copy: "Kopyala",
        edit: "Düzenle",
        delete: "Sil",
        yes: "Evet",
        no: "Hayır",
        cancel: "Vazgeç",
        close: "Kapat",
        refresh: "Yenile",
        update: "Güncelle",
        filter: "Filtrele",
        save: "Kaydet",
        saveAll: "Tümünü Kaydet",
        select: "Seç",
        selectFile: "Dosya Seç",
        upload: "Yükle",
        download: "İndir",
        action: "İşlem",
        previous: "Önceki",
        ensuing: "Sonraki",
        next: "İleri",
        back: "Geri",
        send: "Gönder",
        ok: "Tamam",
        clear: "Temizle",
        tryAgain: "Tekrar Deneyin!",
        apply: "Uygula",
        reset: "Sıfırla",
        resetChoose: "Seçimi Sıfırla",
        change: "Değiştir",
        check: "Denetle",
        remove: "Kaldır",
        selectedRowEvent: "Seçili Kayıt İşlemleri"
    },
    validation: {
        required: "Bu alan gereklidir.",
        email: "Bu alan geçerli bir e-posta olmalıdır.",
        number: "Bu alan geçerli bir sayı olmalıdır.",
        confirmed: "Bu alan onayı eşleşmiyor.",
        length: "Bu alanda 2 seçenek olmalıdır.",
        password: "Lütfen geçerli bir şifre girin.",
        passwordConfirmation: "Lütfen şifreyi tekrar girin.",
        dontMatchPassword: "Şifre alanları birbiriyle eşleşmiyor!"
    },
    customTable: {
        noData: "Listelenecek veri bulunamadı.",
        showingPageInformationPattern: "%s kayıttan, %d ile %d arası gösteriliyor",
        customPhoneInput: "Ülke Ara...",
    },
    formElement: {
        title: "Form Elemanları",
        titlePattern: "%s - Form Elemenları",
        subTitle: "Form Eleman Listesi",
        new: "Yeni Form Elemanı",
        edit: "Eleman Düzenleme",
        elementAttributeSettings: "Eleman Özellik Ayarları",
        elementAvailableAttributes: "Kullanılabilir Özellikler",
        elementItems: "Eleman Öğeleri",
        cols: {
            type: "Tip",
            name: "Ad",
            title: "Başlık",
            description: "Açıklama",
        },
        inputTypes: {
            text: "Metin",
            email: "E-Posta",
            mobile_phone: "Cep Telefonu",
            password: "Şifre",
            number: "Sayı",
            radio: "Radyo",
            checkbox: "Onay Kutusu",
            file: "Dosya"
        },
        addItem: {
            value: "Değer",
            text: "Metin"
        },
        attributes: {
            class: "Class",
            accept: "Accept",
            required: "Zorunlu",
            placeholder: "Placeholder",
            size: "Boyut",
            min: "Min. Sınır",
            max: "Maks. Sınır",
            rows: "Satır Sayısı",
            cols: "Sütun Sayısı",
            maxlength: "Max. Uzunluk",
            minlength: "Min. Uzunluk",
            step: "Arttırım",
            multiple: "Çoklu",
            enable_other: "Diğer Seçeneği",
            unique: "Benzersiz"
        },
        informationBoxes: {
            elementAvailableAttributes: "Form elemanlarının davranışlarını değiştirmek için aşağıdaki alandan bir seçim yaparak ek özellikler belirtebilirsiniz.",
            attributes: {
                enable_other: "Bu form elemanına tanımladığınız cevaplar haricinde başka bir yanıt alınmasını istiyorsanız bu özelliği etkinleştirebilirsiniz.",
                unique: "Bu özellik, her kullanıcıdan yalnızca bir yanıt alınmasını gerektiren durumlarda benzersiz cevaplar elde etmeye yardımcı olur. Örneğin, bir kullanıcının \"E-Posta\" adresi talep ediliyorsa ve bu adrese ait yalnızca tek bir yanıt isteniyorsa, bu özelliği kullanabilirsiniz."
            }
        },
        warnings: {
            fillElementItems: "Lütfen öğenin değer ve metin alanını tam doldurun.",
            fillElementItemsJustText: "Lütfen eklenecek öğenin metin alanını doldurunuz.",
            elementRequiredItems: "Öğe eklemelisiniz.",
            fillAddedElementItems: "Lütfen daha önce eklediğiniz öğeleri tam doldurun.",
            fillAddedElementRowItems: "Lütfen daha önceden eklediğiniz satır öğelerini kontrol ediniz.",
            fillAddedElementColumnItems: "Lütfen daha önceden eklediğiniz satır öğelerini kontrol ediniz.",
            elementRequiredRowItems: "Lütfen en az 1 adet satır ekleyeniz.",
            elementRequiredColumnItems: "Lütfen en az 1 adet sütun ekleyeniz."
        }
    },
    userMenu: {
        language: "Dil",
        theme: {
            title: 'Tema',
            dark: 'Koyu Mod',
            light: 'Aydınlık Mod',
            darkSort: 'Koyu',
            lightSort: 'Aydınlık',
            midnightSort: 'Gece Yarısı',
            creamSort: 'Krem',
            system: 'Otomatik',
            themeStyle: 'Tema Stili',
        },
        layout: {
            content: {
                title: "Layout",
                default: "Sınırlı Ekran",
                fluid: "Tam Ekran",
            }
        },
        syncSettings: "Ayarları cihazlar arası senkronize et",
        accountSettings: "Hesap Ayarları",
        signOut: "Çıkış Yap"
    },
    footer: {
        copyrightText: "Tüm hakları saklıdır."
    },
    endpointActions: {
        get: "Görüntüleme",
        post: "Ekleme",
        put: "Güncelleme",
        delete: "Silme"
    },
    datepicker: {
        months: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
        monthsShort: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
        weekdays: ['Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct', 'Pz'],
    },
    responseErrors: {
        record_not_found: "Kayıt bulunamadı, silinmiş veya taşınmış olabilir.",
        method_not_found: "Method bulunamadı, silinmiş veya taşınmış olabilir.",
        the_discounted_price_cannot_be_higher_than_the_regular_price: "İndirimli fiyat, normal fiyattan daha büyük olamaz.",
        provider_handler_not_found_by_code: "Koda göre sağlayıcı bulunamadı.",
        validate_error: "Doğrulama Hatası",
        delete_meeting_error: "Manuel silinmiş kayıtları silemezsiniz",
        remaining_payment_exists: "Bu işlemin ödemesi alınmamış, önce ödemeyi alınız!",
        module_access_denied: "Bu modüle erişim yetkiniz bulunmuyor. Aboneliğiniz sona ermiş olabilir.",

        stock_code_already_exists: "Bu stok kodu zaten kullanımda.",
        cannot_delete_location_with_stock: "Bu depoda hâlâ ürün var. Önce başka depoya transfer edin veya stoğu sıfırlayın.",
        at_least_one_default_warehouse_required: "Şirkette en az bir varsayılan depo bulunmak zorunda.",
        cannot_delete_last_warehouse: "Şirketin son deposu silinemez.",
        warehouse_has_stock_locations: "Bu depoda stok kayıtları var. Önce ürünleri başka depoya taşıyın.",
        adjustment_movement_cannot_be_deleted: "Düzeltme hareketleri silinemez, audit için saklanır.",
        module_only_for_root_category: "Modül yalnızca ana kategorilere atanabilir.",
        invalid_stock_location_id: "Seçili lokasyon bu ürüne ait değil.",
        location_already_exists: "Bu ürün zaten bu depoya kayıtlı.",
        circular_category_reference: "Kategori döngüsel bir referans oluşturuyor.",
        category_tree_has_stocks: "Kategori ağacında ürün kayıtları var. Önce ürünleri taşıyın veya silin.",
        insufficient_stock: "Kaynak depoda yeterli stok yok.",
        cannot_transfer_to_same_warehouse: "Aynı depoya transfer yapılamaz.",
        stock_not_in_source_warehouse: "Ürünün kaynak depoda kaydı yok.",
        invalid_from_warehouse_id: "Geçersiz kaynak depo.",
        invalid_to_warehouse_id: "Geçersiz hedef depo.",
        invalid_warehouse_id: "Geçersiz depo.",
        invalid_stock_category_id: "Geçersiz stok kategorisi.",
        invalid_module_id: "Modül bu şirkette aktif değil.",
        invalid_parent_id: "Geçersiz üst kategori.",
        category_cannot_be_its_own_parent: "Kategori kendisinin üst kategorisi olamaz.",
        invalid_stock_id: "Geçersiz ürün kaydı.",
        invalid_unit_id: "Geçersiz birim.",

        no_cash_register: "Varsayılan kasa tanımlı değil. Lütfen bir kasa seçin veya tanımlayın.",
        at_least_one_default_cash_register_required: "Şirkette en az bir varsayılan kasa bulunmak zorunda.",
        cannot_delete_last_cash_register: "Şirketin son kasası silinemez.",
        invalid_cash_register_id: "Seçili kasa bu şirkete ait değil.",
        invalid_direction_id: "Geçersiz hareket yönü.",

        payment_exceeds_total_amount: "Bu tutar, işlemin toplam tutarını aşıyor.",
        unsupported_payment_method: "Bu ödeme yöntemi seçili modül için geçerli değil.",
        cannot_delete_module_transaction: "Modülden açılmış tahsilat bu ekrandan silinemez.",
        payment_method_not_available_for_transaction: "Bu ödeme yöntemi tahsilat işlemlerinde kullanılamıyor.",
        module_does_not_support_transactions: "İlgili modül tahsilat işlemini desteklemiyor.",
        installment_only_for_income: "Taksit planı sadece tahsilat işlemlerinde kurulabilir.",
        invalid_installment_count: "Taksit sayısı 2 ile 48 arasında olmalı.",
        installment_payment_method_not_found: "Sistemde 'Elden Taksit' yöntemi tanımlı değil.",
        no_remaining_amount: "Kalan tutar yok, taksit planı kurulamaz.",
        invalid_transaction_id: "İlgili tahsilat kaydı bulunamadı.",
        invalid_payment_method_id: "Geçersiz ödeme yöntemi.",
        payment_method_id_required_when_paid_amount: "Tahsil edilecek tutar için ödeme yöntemi seçin.",
    }
};